import API from '../../shared/Config/API';
import APIEndpoints from '../../shared/Config/APIEndpoints';

const fetchAllConfigs = async () => {
  try {
    return await API.get(APIEndpoints.FETCH_EPR_CONFIGS);
  } catch (error) {
    console.error(error);
  }
};
export const ConfigsApi = {
  fetchAllConfigs,
};
